import { getElementById } from "../services/dom";
import notfoundTemplate from "../templates/pages/notfound.html?raw";
import logoUrl from "../assets/logo.png";

export default class NotFoundPage {
  constructor() {
    this.loadPage();
  }

  public loadPage(): void {
    document.querySelector<HTMLDivElement>("#app")!.innerHTML = notfoundTemplate;

    // Set up Logo
    const logoElement = getElementById("section-logo");
    const logoImgMobile = document.createElement("img");
    logoImgMobile.src = logoUrl;
    logoImgMobile.alt = "Logo";
    logoImgMobile.classList.add("login-image");
    logoElement.appendChild(logoImgMobile);
  }
}
